<template>
  <div>
    <v-toolbar
      dense
      floating
      style="width: 100%; heigth: 58px"
    >
      <v-btn icon @click="setCurrentPos">
        <v-icon>{{ mdiCrosshairsGps }}</v-icon>
      </v-btn>
      <GmapAutocomplete @place_changed="setPlace">
      </GmapAutocomplete>
    </v-toolbar>
    <v-toolbar
      dense
      floating
      style="width: 100%"
    >
      <DateRangePicker v-model="dateRange" class="text-right" />
      <v-btn class="ml-2" color="primary" @click="selectLastDay">
        {{ $t('common.buttons.lastDay') }}
      </v-btn>
    </v-toolbar>
    <GmapMap ref="map"
      :center="currentCoords"
      :zoom="12"
      map-type-id="terrain"
      style="width: 100%; height: 400px"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      }"
    >
      <GmapMarker
        v-for="(incident, i) in filteredIncidents"
        :position="parseMapItemPoint(incident.location)"
        :key="`marker-${incident.id}-${i}`"
        :clickable="true"
        :draggable="false"
        @click="toggleInfoWindow(incident,i)"
        :icon="getIcon(incident.isRecent)"
      >
      </GmapMarker>
      <GmapInfoWindow
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
          {{ currentIncident.description }}
          <v-img v-if="currentIncident.imageUrl" contain :src="currentIncident.imageUrl" />
          <span class="d-block text-subtitle-2 text-right" style="font-size: smaller !important;">
            {{ formatDateTime(currentIncident.created) }}
          </span>
      </GmapInfoWindow>
    </GmapMap>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { gmapApi } from 'vue2-google-maps';
import { mdiCrosshairsGps, mdiFilter, mdiMagnify } from '@mdi/js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import DateRangePicker from './DateRangePicker.vue';

dayjs.extend(isBetween);

export default {
  components: { DateRangePicker },
  name: 'IncidentsMap',
  props: ['incidents', 'currentCoords'],
  data() {
    return {
      mdiCrosshairsGps,
      mdiFilter,
      mdiMagnify,
      dateRange: {
        start: dayjs().subtract(7, 'day').toDate(),
        end: dayjs().toDate(),
      },
      currentMidx: null,
      content: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: '',
        // optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    };
  },
  computed: {
    google: gmapApi,
    currentIncident() {
      return this.incidents[this.currentMidx] ?? {};
    },
    filteredIncidents() {
      if (!this.dateRange) {
        return this.incidents;
      }
      return this.incidents.filter((i) => dayjs(i.created)
        .isBetween(this.dateRange.start, this.dateRange.end, null, '[]'));
    },
  },

  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit('input', this.localValue);
    },
  },
  mounted() {
    this.localValue = this.value;
  },
  methods: {
    getIcon(isRecent) {
      if (isRecent) {
        return require('../assets/new-incidents.png');
      }
      return require('../assets/old-incidents.png');
    },
    async mapToBounds() {
      this.$log.info('mapping to bounds');
      const pos = this.currentPosition;
      if (this.$refs.map && pos) {
        const map = await this.$refs.map.$mapPromise;
        this.$log.info(pos);
        const mapPos = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        map.panTo(mapPos);

        const bounds = new this.google.maps.LatLngBounds();
        bounds.extend(new this.google.maps.LatLng(mapPos.lat, mapPos.lng));
        this.incidents.forEach((p) => {
          bounds.extend(this.parseMapItemPoint(p.location));
        });
        map.fitBounds(bounds);
        // map.fitBounds(bounds);
        map.panToBounds(bounds);
      }
    },
    /** Method used parse server geography to google lantLng
     */
    parseMapItemPoint(point) {
      if (!point) {
        return undefined;
      }
      const coord = point?.geography?.wellKnownText?.replace('POINT ', '')
        .replace('(', '')
        .replace(')', '');
      const coordArr = coord.split(/[ ,]+/);
      const lat = parseFloat(coordArr[1]);
      const lng = parseFloat(coordArr[0]);
      this.$log.info(coordArr);
      // eslint-disable-next-line no-undef
      if (this.google) {
        const latLng = new this.google.maps.LatLng(lat, lng) ?? {};
        return latLng;
      }
      return {};
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = this.parseMapItemPoint(marker.location);
      this.content = marker.description;

      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.currentMidx = idx;
        this.infoWinOpen = true;
        this.$log.info('opened info window');
      }
    },
    setCurrentPos() {
      const self = this;
      navigator.geolocation.getCurrentPosition((pos) => {
        self.mapPos = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        self.$refs.map.$mapPromise.then((map) => {
          map.panTo(self.mapPos);
        });
      });
    },
    selectLastDay() {
      this.dateRange = {
        start: dayjs().subtract(1, 'day').toDate(),
        end: dayjs().toDate(),
      };
    },
    setPlace(place) {
      this.$refs.map.$mapPromise.then((map) => {
        this.$log.info(place);
        map.panTo(place.geometry.location);
      });
      // this.place = place;
    },
    usePlace() {
      if (this.place) {
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          });
          this.place = null;
        });
      }
    },
  },
};
</script>
